import React, { Component } from 'react'
import "./PayKomp.css"


class PayKomp extends React.Component {
  constructor(props) {
    super(props);
    this.state = { PAYMENT: [] };
  }

  componentDidMount() {
    this.setState({
      PAYMENT: this.props.PAYMENT,
    });
 
  }

  render() {
    const Payment = this.state.PAYMENT;

    let PaymentTable = [];
    let ComgTable = [];
    let ConsnTable = [];

    if (Payment) {
      let PayData = [];
      let ComgData = [];
      let ConsnData = [];

      if (Payment[0]) {

        if (Payment[0].length) {

          PaymentTable.push(
            <table>
              <thead>
                <tr className="Payment_shapka">
                  <th>Курс</th>
                  <th>Уч. год</th>
                  <th>Контракт</th>
                  <th>Оплатил</th>
                  <th>Долг</th>
                  <th>Специальность в которую оплатил</th>
                </tr>
                {PayData}
              </thead>
            </table>
          );
          for (let j = 0; j < Payment[0].length; j++) {
            PayData.push(
              <tr className="PayData">
                <td>{Payment[0][j].id_rate}</td>
                <td>{Payment[0][j].years1}</td>
                <td>{Payment[0][j].smeta}</td>
                <td>{Payment[0][j].sum_opl}</td>
                <td>{Payment[0][j].dolg}</td>
                <td>{Payment[0][j].spec1}</td>
              </tr>
            );
          }
        }
        if (Payment[1].length) {
          ComgTable.push(
            <table>
              <thead>
                <tr className="Comg_header">
                  <th colSpan="8">Приход</th>
                </tr>
                <tr className="Comg_shapka">
                  <th>№ п/п</th>
                  <th>Уч. год</th>
                  <th>Оплата (сом)</th>
                  <th>Дата</th>
                  <th>№ ордера</th>
                  <th>Вид оплаты</th>
                  <th>Специальность </th>
                  <th>Целевое назначание</th>
                </tr>
                {ComgData}
              </thead>
            </table>
          );
          for (let k = 0; k < Payment[1].length; k++) {
            ComgData.push(
              <tr className="ComgData">
                <td>{k + 1}</td>
                <td>{Payment[1][k].years2}</td>
                <td>{Payment[1][k].prihod}</td>
                <td>{Payment[1][k].dates2}</td>
                <td>{Payment[1][k].orders2}</td>
                <td>{Payment[1][k].vid_opl2}</td>
                <td>{Payment[1][k].spec2}</td>
                <td>{Payment[1][k].uslugi2}</td>
              </tr>
            );
          }
        }
        if (Payment[2].length) {
          ConsnTable.push(
            <table>
              <tbody>
                <tr className="Consn_header">
                  <th colSpan="7">Расход</th>
                </tr>
                <tr className="Consn_shapka">
                  <th>№ п/п</th>
                  <th>Уч. год</th>
                  <th>Расход (сом)</th>
                  <th>Дата</th>
                  <th>№ ордера</th>
                  <th>Вид оплаты</th>
                  <th>Целевое назначание</th>
                </tr>
                {ConsnData}
              </tbody>
            </table>
          );
          for (let l = 0; l < Payment[2].length; l++) {
            ConsnData.push(
              <tr className="ConsnData">
                <td>1</td>
                <td>{Payment[2][l].years3}</td>
                <td>{Payment[2][l].rashod}</td>
                <td>{Payment[2][l].dates3}</td>
                <td>{Payment[2][l].orders3}</td>
                <td>{Payment[2][l].vid_opl3}</td>
                <td>{Payment[2][l].uslugi3}</td>
              </tr>
            );
          }

        } else {
          <h1>Пока нет данных!</h1>;
        }
      } else {
      }
    }
    else return null;

    return (
      <div>
        <div className="Pay_table">{PaymentTable}</div>
        <div className="Comming_table">{ComgTable}</div>
        <div className="Consumption_table">{ConsnTable}</div>
      </div>
    );
  }
}



export default PayKomp;